export default "__VITE_ASSET__96ed2db5__"